module.exports = __webpack_public_path__ + "media/assets/ruby_gray-c953249221a42f1823d2e7cf6d36e162.svg";